import { render, staticRenderFns } from "./RtbCard.vue?vue&type=template&id=3ee20296&scoped=true&"
import script from "./RtbCard.vue?vue&type=script&lang=js&"
export * from "./RtbCard.vue?vue&type=script&lang=js&"
import style0 from "./RtbCard.vue?vue&type=style&index=0&id=3ee20296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee20296",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee20296')) {
      api.createRecord('3ee20296', component.options)
    } else {
      api.reload('3ee20296', component.options)
    }
    module.hot.accept("./RtbCard.vue?vue&type=template&id=3ee20296&scoped=true&", function () {
      api.rerender('3ee20296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/Games/RtbCard.vue"
export default component.exports